// Port of api/fuel/app/classes/filter/search/games/filters/query/game/subset.php
export default {
	name: 'game.subset',
	priority: 3,
	require: function(config, filter) {
		return filter.games && filter.games.subset && filter.games.subset.length > 0
	},
	run: function(config, filter, data, query) {
		query.where('g.game_id', 'in', filter.games.subset)
	}
}
